import styled from '@emotion/styled';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';

export const WidgetTrapBox = styled('div', { label: 'WidgetTrapBox' })`
    align-items: center;
    display: flex;
    flex: 0 0 32px;
    height: 32px;
    justify-content: center;
`;

export const TrapWrapperNextRaces = styled(Trap, { label: 'TrapWrapperNextRaces' })`
    height: 32px;
    width: 32px;
`;
